import Select from 'react-select'
import RadioInput from './RadioInput'
import { FormikProps } from 'formik'
import { InitialState as SurveyInitialState } from 'Store/Survey'
import clsx from 'clsx'

interface Props {
  isView?: boolean
  formik: FormikProps<SurveyInitialState>
}

// const MOCK_SURFACE_OPTIONS = [
//   {
//     label: 'ดินเก่า',
//     value: 'ดินเก่า',
//   },
//   {
//     label: 'ดินใหม่',
//     value: 'ดินใหม่',
//   },
//   {
//     label: 'ผิวเรียบ',
//     value: 'ผิวเรียบ',
//   },
//   {
//     label: 'ผิวไม่เรียบ',
//     value: 'ผิวไม่เรียบ',
//   },
//   {
//     label: 'เป็นสวน,ทุ่งนา',
//     value: 'เป็นสวน,ทุ่งนา',
//   },
//   {
//     label: 'พื้นบดอัดด้วยทราย',
//     value: 'พื้นบดอัดด้วยทราย',
//   },
//   {
//     label: 'พื้นบดอัดด้วยลูกรัง',
//     value: 'พื้นบดอัดด้วยลูกรัง',
//   },
//   {
//     label: 'พื้นปูน',
//     value: 'พื้นปูน',
//   },
// ]

const MOCK_SURFACE_ADDITONAL_OPTIONS = [
  {
    label: 'พื้นดินถมเพิ่มสูงจากระดับดินเดิม (ไม่มีการบดอัด)',
    value: '(ไม่มีการบดอัด)',
  },
  {
    label: 'พื้นดินถมเพิ่มสูงจากระดับดินเดิม (มีการบดอัดตามหลักวิศวกรรม)',
    value: '(มีการบดอัดตามหลักวิศวกรรม)',
  },
  {
    label: 'พื้นดินขุดต่ำจากดินเดิม',
    value: 'พื้นดินขุดต่ำจากดินเดิม',
  },
  {
    label: 'ค่าระดับดินเดิม',
    value: 'ค่าระดับดินเดิม',
  },
]

const Obstacle: React.FC<Props> = ({ isView, formik }) => {
  return (
    <div className='card'>
      <div className='card-header'>
        <div className='card-title fw-bold'>ส่วนที่ 2 - อุปสรรคและปัญหา</div>
      </div>

      <div className='card-body'>
        <div className='row gx-3 gy-8'>
          {/* begin:: Ground Obstacle */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='obstacleOnGround'
              label='อุปสรรคบนดิน'
              options={[
                {
                  id: 'groundObstacleNo',
                  label: 'ไม่มี',
                  value: 'ไม่มี',
                },
                {
                  id: 'groundObstacleYes',
                  label: 'มี',
                  value: 'มี',
                  inputPlaceholder: 'ระบุ',
                  hasInput: formik.values.obstacleOnGround === 'มี',
                  inputValue: formik.values.obstacleOnGroundRemark,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('obstacleOnGroundRemark', val)
                  },
                },
              ]}
              checked={formik.values.obstacleOnGround}
              onChange={(val: any) => {
                formik.setFieldValue('obstacleOnGround', val)
              }}
            />
          </div>
          {/* end:: Ground Obstacle */}

          {/* begin:: Underground Obstacle */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='obstacleUnderGround'
              label='อุปสรรคใต้ดิน'
              options={[
                {
                  id: 'undergroundObstacleNo',
                  label: 'ไม่มี',
                  value: 'ไม่มี',
                },
                {
                  id: 'undergroundObstacleYes',
                  label: 'มี',
                  value: 'มี',
                  inputPlaceholder: 'ระบุ',
                  hasInput: formik.values.obstacleUnderGround === 'มี',
                  inputValue: formik.values.obstacleUnderGroundRemark,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('obstacleUnderGroundRemark', val)
                  },
                },
              ]}
              checked={formik.values.obstacleUnderGround}
              onChange={(val: any) => {
                formik.setFieldValue('obstacleUnderGround', val)
              }}
            />
          </div>
          {/* end:: Underground Obstacle */}

          {/* begin:: Truck Entrace */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='truckEntrance'
              label='ลักษณะทางเข้าของรถบรรทุก'
              options={[
                {
                  id: 'noEntranceTruckProblem',
                  label: 'ไม่มีปัญหา',
                  value: 'ไม่มีปัญหา',
                },
                {
                  id: 'haveEntranceTruckProblem',
                  label: 'มีปัญหา',
                  value: 'มีปัญหา',
                },
              ]}
              checked={formik.values.truckEntrance}
              onChange={(val: any) => {
                formik.setFieldValue('truckEntrance', val)
              }}
            />
          </div>
          {/* end:: Truck Entrace */}

          <div className='separator border-2' />

          {/* begin:: Entrance Size */}
          <div className='col-12'>
            <div className='row'>
              <div className='mb-3 fs-6 col-12 col-xl-3'>ประตูทางเข้า: </div>

              <div className='col-12 col-xl-9'>
                <div className='row gy-5'>
                  <div className='col-12 col-xl-3'>
                    กว้าง
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className={clsx('form-control form-control-sm', {
                          'is-invalid': formik.touched.entranceWidth && formik.errors.entranceWidth,
                        })}
                        name={`entranceWidth`}
                        value={formik.values.entranceWidth}
                        onChange={(e: any) => {
                          formik.setFieldValue('entranceWidth', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      {formik.touched.entranceWidth && formik.errors.entranceWidth && (
                        <div className='invalid-feedback'>{formik.errors.entranceWidth}</div>
                      )}
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    ยาว
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className={clsx('form-control form-control-sm', {
                          'is-invalid':
                            formik.touched.entranceLength && formik.errors.entranceLength,
                        })}
                        name={`entranceLength`}
                        value={formik.values.entranceLength}
                        onChange={(e: any) => {
                          formik.setFieldValue('entranceLength', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      {formik.touched.entranceLength && formik.errors.entranceLength && (
                        <div className='invalid-feedback'>{formik.errors.entranceLength}</div>
                      )}
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-3'>
                    สูง
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`entranceHeight`}
                        value={formik.values.entranceHeight}
                        onChange={(e: any) => {
                          formik.setFieldValue('entranceHeight', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end:: Entrance Size */}

          <div className='separator border-2' />

          {/* begin:: Dimension */}
          <div className='col-12'>
            <div className='row'>
              <div className='mb-3 fs-6 col-12 col-xl-3'>ขนาดของพื้นที่ผัง: </div>
              <div className='col-xl-9 col-12'>
                <div className='row gy-5'>
                  <div className='col-12 col-xl-4'>
                    &nbsp;
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`areaRai`}
                        value={formik.values.areaRai}
                        onChange={(e: any) => {
                          formik.setFieldValue('areaRai', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (ไร่)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-4'>
                    &nbsp;
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`areaNgan`}
                        value={formik.values.areaNgan}
                        onChange={(e: any) => {
                          formik.setFieldValue('areaNgan', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (งาน)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-4'>
                    &nbsp;
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`areaSquareWa`}
                        value={formik.values.areaSquareWa}
                        onChange={(e: any) => {
                          formik.setFieldValue('areaSquareWa', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (ตารางวา)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-4'>
                    กว้าง
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`areaWidth`}
                        value={formik.values.areaWidth}
                        onChange={(e: any) => {
                          formik.setFieldValue('areaWidth', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                  <div className='col-12 col-xl-4'>
                    ยาว
                    <div className='position-relative w-100'>
                      <input
                        type='text'
                        className='form-control form-control-sm'
                        name={`areaLength`}
                        value={formik.values.areaLength}
                        onChange={(e: any) => {
                          formik.setFieldValue('areaLength', e.currentTarget.value)
                        }}
                        disabled={isView}
                      />
                      <div
                        className='position-absolute text-gray-500'
                        style={{ top: '22%', right: 10 }}>
                        (เมตร)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* end:: Dimension */}

          <div className='separator border-2' />

          {/* begin:: Fence */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='areaFence'
              label='รั้วเขตขอบผัง'
              options={[
                {
                  id: 'noFence',
                  label: 'ไม่มี',
                  value: 'ไม่มี',
                },
                {
                  id: 'haveFence',
                  label: 'มี',
                  value: 'มี',
                },
              ]}
              checked={formik.values.areaFence}
              onChange={(val: any) => {
                formik.setFieldValue('areaFence', val)
              }}
            />
          </div>
          {/* end:: Fence */}

          {/* begin:: GradingHeight */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='levelOfArea'
              label='ระดับขอบผัง'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'เสมอถนนทางเข้า',
                  value: 'เสมอถนนทางเข้า',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'สูงกว่าขอบผัง',
                  value: 'สูงกว่าขอบผัง',
                  hasInput: formik.values.levelOfArea === 'สูงกว่าขอบผัง',
                  inputValue: formik.values.levelOfAreaHigherLevel,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('levelOfAreaHigherLevel', val)
                  },
                  inputWidth: 200,
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'ต่ำกว่าขอบผัง',
                  value: 'ต่ำกว่าขอบผัง',
                  hasInput: formik.values.levelOfArea === 'ต่ำกว่าขอบผัง',
                  inputValue: formik.values.levelOfAreaLowerLevel,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('levelOfAreaLowerLevel', val)
                  },
                  inputWidth: 200,
                },
                {
                  id: 'otherGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.levelOfArea}
              onChange={(val: any) => {
                formik.setFieldValue('levelOfArea', val)
              }}
            />
          </div>
          {/* end:: GradingHeight */}

          <div className='separator border-2' />

          {/* begin:: Surface */}
          <div className='col-12 col-xl-3'>
            <label htmlFor='type' className='fs-6 mb-3'>
              สภาพพื้นผิว:
            </label>
          </div>

          <div className='col-12 col-xl-3'>
            <input
              {...formik.getFieldProps('areaCondition')}
              className='form-control form-control-sm'
              name='areaCondition'
              placeholder='ex. ดินเก่า 60%, ดินใหม่ 40%'
              disabled={isView}
            />
            {/* <Select
              name={`type`}
              isSearchable={true}
              options={MOCK_SURFACE_OPTIONS}
              styles={{
                control: (provided  :any) =>  ({
                  ...provided,
                  borderColor: '#e1e3ea',
                }),
              }}
              value={
                MOCK_SURFACE_OPTIONS.find(option => option.value === formik.values.areaCondition) ??
                null
              }
              onChange={(val :any) => {
                formik.setFieldValue('areaCondition', val?.value)
              }}
            /> */}
          </div>

          <div className='d-none d-xl-block col-xl-6' />
          {/* end:: Surface */}

          {/* begin:: Additional Surface */}
          <div className='col-12 col-xl-3'>
            <label htmlFor='areaConditionAddition' className='fs-6 mb-3'>
              เพิ่มเติม:
            </label>
          </div>

          <div className='col-12 col-xl-3'>
            <Select
              name={`areaConditionAddition`}
              isSearchable={true}
              isDisabled={isView}
              options={MOCK_SURFACE_ADDITONAL_OPTIONS}
              styles={{
                control: (provided: any) => ({
                  ...provided,
                  borderColor: '#e1e3ea',
                }),
              }}
              value={
                MOCK_SURFACE_ADDITONAL_OPTIONS.find(
                  option => option.value === formik.values.areaConditionAddition
                ) ?? null
              }
              onChange={(val: any) => {
                formik.setFieldValue('areaConditionAddition', val?.value)
              }}
            />
          </div>

          <div className='d-none d-xl-block col-xl-6' />
          {/* end:: Additional Surface */}

          <div className='separator border-2' />

          {/* begin:: Width of Entrance */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='roadEntrance'
              label='ถนนทางเข้ากว้าง'
              options={[
                {
                  id: 'haveRoadEntrance',
                  label: 'มีถนน',
                  value: 'มีถนน',
                  hasInput: formik.values.roadEntrance === 'มีถนน',
                  inputValue: formik.values.roadEntranceWidth,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('roadEntranceWidth', val)
                  },
                  inputWidth: 200,
                  inputUnit: '(เมตร)',
                },
                {
                  id: 'dontHaveRoadEntrance',
                  label: 'ไม่มีถนน',
                  value: 'ไม่มีถนน',
                },
              ]}
              checked={formik.values.roadEntrance}
              onChange={(val: any) => {
                formik.setFieldValue('roadEntrance', val)
              }}
            />
          </div>
          {/* end:: Width of Entrance */}

          <div className='separator' />

          {/* begin:: Road */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveRoadInside'
              label='ถนนภายในผัง'
              options={[
                {
                  id: 'roadInsideCharacter',
                  label: 'มีลักษณะ',
                  value: 'มีลักษณะ',
                  hasInput: formik.values.haveRoadInside === 'มีลักษณะ',
                  inputValue: formik.values.haveRoadInsideRemark1,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('haveRoadInsideRemark1', val)
                  },
                  inputWidth: 200,
                },
                {
                  id: 'customerResponsible',
                  label: 'ไม่มี ลูกค้ารับผิดชอบจัดทำจำนวน',
                  value: 'ไม่มี ลูกค้ารับผิดชอบจัดทำจำนวน',
                  hasInput: formik.values.haveRoadInside === 'ไม่มี ลูกค้ารับผิดชอบจัดทำจำนวน',
                  inputValue: formik.values.haveRoadInsideRemark2,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('haveRoadInsideRemark2', val)
                  },
                  inputWidth: 200,
                },
                {
                  id: 'pacoResponsible',
                  label: 'ไม่มี PACO รับผิดชอบจัดทำจำนวน',
                  value: 'ไม่มี PACO รับผิดชอบจัดทำจำนวน',
                  hasInput: formik.values.haveRoadInside === 'ไม่มี PACO รับผิดชอบจัดทำจำนวน',
                  inputValue: formik.values.haveRoadInsideRemark3,
                  inputOnChange: (val: string) => {
                    formik.setFieldValue('haveRoadInsideRemark3', val)
                  },
                  inputWidth: 200,
                },
              ]}
              checked={formik.values.haveRoadInside}
              onChange={(val: any) => {
                formik.setFieldValue('haveRoadInside', val)
              }}
            />
          </div>
          {/* end:: Road */}

          <div className='separator' />

          {/* begin:: Tunnel */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveProblem1'
              label='บ่อบาดาล,อุโมงค์,กปน,รฟม'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'มีปัญหา',
                  value: 'มีปัญหา',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ไม่มีปัญหา',
                  value: 'ไม่มีปัญหา',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ ',
                  value: 'อื่นๆ ',
                },
              ]}
              checked={formik.values.haveProblem1}
              onChange={(val: any) => {
                formik.setFieldValue('haveProblem1', val)
              }}
            />
          </div>
          {/* end:: Tunnel */}

          {/* begin:: Fire Hydrant */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveProblem2'
              label='ท่อประปา,หัวดับเพลิง'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'มีปัญหา',
                  value: 'มีปัญหา',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ไม่มีปัญหา',
                  value: 'ไม่มีปัญหา',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ ',
                  value: 'อื่นๆ ',
                },
              ]}
              checked={formik.values.haveProblem2}
              onChange={(val: any) => {
                formik.setFieldValue('haveProblem2', val)
              }}
            />
          </div>
          {/* end:: Fire Hydrant */}

          {/* begin:: Telephone */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='haveProblem3'
              label='สายไฟ,สายโทรศัพท์'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'มีปัญหา',
                  value: 'มีปัญหา',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ไม่มีปัญหา',
                  value: 'ไม่มีปัญหา',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ ',
                  value: 'อื่นๆ ',
                },
              ]}
              checked={formik.values.haveProblem3}
              onChange={(val: any) => {
                formik.setFieldValue('haveProblem3', val)
              }}
            />
          </div>
          {/* end:: Telephone */}

          <div className='separator border-2' />

          {/* begin:: Pile Point */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='polePointSurface'
              label='จุดกองเสา'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'ผิวเรียบ',
                  value: 'ผิวเรียบ',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ผิวขรุขระ',
                  value: 'ผิวขรุขระ',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'เป็นหลุมบ่อ',
                  value: 'เป็นหลุมบ่อ',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ ',
                  value: 'อื่นๆ ',
                },
              ]}
              checked={formik.values.polePointSurface}
              onChange={(val: any) => {
                formik.setFieldValue('polePointSurface', val)
              }}
            />
          </div>

          <div className='row mt-3 gy-5'>
            <div className='d-none d-xl-flex col-xl-3' />

            <div className='col-12 col-xl-3'>
              จำนวนกองเสา
              <span className='align-items-center d-flex flex-row' style={{ gap: '12px' }}>
                <div className='position-relative w-100'>
                  <input
                    type='text'
                    className='form-control form-control-sm me-5'
                    name={`polePointSurfaceAmount2`}
                    value={formik.values.polePointSurfaceAmount2}
                    onChange={(e: any) => {
                      formik.setFieldValue('polePointSurfaceAmount2', e.currentTarget.value)
                    }}
                    disabled={isView}
                  />
                  <div
                    className='position-absolute text-gray-500'
                    style={{ top: '22%', right: 10 }}>
                    (จุด)
                  </div>
                </div>
              </span>
            </div>

            <div className='col-12 col-xl-3'>
              ครั้งละ
              <span className='align-items-center d-flex flex-row' style={{ gap: '12px' }}>
                <div className='position-relative w-100'>
                  <input
                    type='text'
                    className='form-control form-control-sm me-5'
                    name={`polePointSurfaceAmount3`}
                    value={formik.values.polePointSurfaceAmount3}
                    onChange={(e: any) => {
                      formik.setFieldValue('polePointSurfaceAmount3', e.currentTarget.value)
                    }}
                    disabled={isView}
                  />
                  <div
                    className='position-absolute text-gray-500'
                    style={{ top: '22%', right: 10 }}>
                    (ต้น)
                  </div>
                </div>
              </span>
            </div>
          </div>
          {/* end:: Pile Point */}

          <div className='separator border-2' />

          {/* begin:: Area Adjustment */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='areaAdjustment'
              label='การปรับพื้นที่/บดอัดพื้นที่'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.areaAdjustment}
              onChange={(val: any) => {
                formik.setFieldValue('areaAdjustment', val)
              }}
            />
          </div>
          {/* end:: Area Adjustment */}

          {/* begin:: Electricity Adjustment */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='electricityPreparation'
              label='การจัดเตรียม ไฟฟ้างานเชื่อม'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.electricityPreparation}
              onChange={(val: any) => {
                formik.setFieldValue('electricityPreparation', val)
              }}
            />
          </div>
          {/* end:: Electricity Adjustment */}

          {/* begin:: Electricity For Resident */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='electricityHouse'
              label='ไฟฟ้า/ประปาบ้านพัก'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.electricityHouse}
              onChange={(val: any) => {
                formik.setFieldValue('electricityHouse', val)
              }}
            />
          </div>
          {/* end:: Electricity For Resident */}

          {/* begin:: Light */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='electricityLight'
              label='ไฟแสงสว่าง'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.electricityLight}
              onChange={(val: any) => {
                formik.setFieldValue('electricityLight', val)
              }}
            />
          </div>
          {/* end:: Light */}

          {/* begin:: Usage Utilities */}
          <div className='col-12'>
            <RadioInput
              name='electricityFCPTG'
              label='ไฟฟ้า/ประปาใช้งาน FC+PTG'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.electricityFCPTG}
              onChange={(val: any) => {
                formik.setFieldValue('electricityFCPTG', val)
              }}
            />
          </div>
          {/* end:: Usage Utilities */}

          {/* begin:: Resident Preparation */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='houseForEmployee'
              label='จัดทำบ้านพักพนักงาน'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.houseForEmployee}
              onChange={(val: any) => {
                formik.setFieldValue('houseForEmployee', val)
              }}
            />
          </div>
          {/* end:: Resident Preparation */}

          {/* begin:: Worker Transportation */}
          <div className='col-12'>
            <RadioInput
              disabled={isView}
              name='employeeTransportation'
              label='รถรับส่งพนักงาน'
              options={[
                {
                  id: 'equalGradingHeight',
                  label: 'PACO',
                  value: 'PACO',
                },
                {
                  id: 'higherGradingHeight',
                  label: 'ลูกค้า',
                  value: 'ลูกค้า',
                },
                {
                  id: 'lowerGradingHeight',
                  label: 'อื่นๆ',
                  value: 'อื่นๆ',
                },
              ]}
              checked={formik.values.employeeTransportation}
              onChange={(val: any) => {
                formik.setFieldValue('employeeTransportation', val)
              }}
            />
          </div>

          <div className='col-12 my-5'>
            <div className='row'>
              <div className='col-12 col-xl-3'>เพิ่มเติม:</div>
              <div className='col-12 col-xl-9'>
                <textarea
                  name='employeeTransportationNote'
                  className='form-control form-control-sm'
                  value={formik.values.employeeTransportationNote}
                  onChange={(e: any) => {
                    formik.setFieldValue('employeeTransportationNote', e.currentTarget.value)
                  }}
                  rows={5}
                  disabled={isView}
                />
              </div>
            </div>
          </div>
          {/* end:: Worker Transportation */}

          <div className='col-12'>
            <label className='fs-6 mb-3'>
              เรื่องอื่นๆ ที่จะต้องจัดเตรียมเพิ่มเติม ,ข้อคิดเห็น ,ข้อเสนอแนะ:
            </label>

            <textarea
              name='noteOther'
              rows={5}
              className='form-control form-control-sm'
              value={formik.values.noteOther}
              onChange={(e: any) => {
                formik.setFieldValue('noteOther', e.currentTarget.value)
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Obstacle
